import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-76245fad"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "submitForm"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "color_999"
}, "提示：默认密码A123456", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Resource = _resolveComponent("Resource");
  const _component_OrganizeSelect = _resolveComponent("OrganizeSelect");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_button = _resolveComponent("el-button");
  const _component_TypeSelect = _resolveComponent("TypeSelect");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_AreaSelect = _resolveComponent("AreaSelect");
  const _component_el_form = _resolveComponent("el-form");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Resource, {
    visible: _ctx.resourceVisible,
    "onUpdate:visible": _cache[0] || (_cache[0] = $event => _ctx.resourceVisible = $event),
    ref: "resourceRef",
    orgId: _ctx.roleOrgId,
    onHandleSuccess: _ctx.getRole
  }, null, 8, ["visible", "orgId", "onHandleSuccess"]), _createVNode(_component_el_form, {
    ref: "ruleForm",
    rules: _ctx.rules,
    model: _ctx.formData,
    "label-width": "110px"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: "上级组织",
      prop: "orgId",
      required: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_OrganizeSelect, {
        modelValue: _ctx.searchValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.searchValue = $event),
        activeValue: _ctx.activeValue,
        isClick: false,
        isSpecify: 'org',
        isDoubleClick: true,
        placeholder: "请输入上级组织",
        onHandleDoubleClick: _ctx.handleDoubleClick
      }, null, 8, ["modelValue", "activeValue", "onHandleDoubleClick"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "所属单位",
      prop: "schoolName"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: _ctx.formData.schoolName,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.formData.schoolName = $event),
        onInput: _cache[3] || (_cache[3] = val => _ctx.formData.loginName = _ctx.formData.schoolName),
        placeholder: "请输入所属单位"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "登录账号",
      prop: "loginName"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        disabled: "",
        modelValue: _ctx.formData.loginName,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.formData.loginName = $event),
        placeholder: "请输入登录账号"
      }, null, 8, ["modelValue"]), _hoisted_2]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "账号权限",
      prop: "roleId",
      required: false
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        class: "w_100 margin_bottom",
        modelValue: _ctx.formData.roleId,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.formData.roleId = $event),
        disabled: ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roleType, item => {
          return _withDirectives((_openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"])), [[_vShow, item.value !== 1]]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[6] || (_cache[6] = $event => _ctx.visibleChange(_ctx.formData.roleId))
      }, {
        default: _withCtx(() => [_createTextVNode("查看权限")]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "单位性质",
      prop: "schoolType"
    }, {
      default: _withCtx(() => [_createVNode(_component_TypeSelect, {
        modelValue: _ctx.formData.schoolType,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.formData.schoolType = $event),
        type: "schoolType"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _withDirectives(_createVNode(_component_el_form_item, {
      label: "阶段",
      prop: "educationStage"
    }, {
      default: _withCtx(() => [_createVNode(_component_TypeSelect, {
        class: "w_100",
        modelValue: _ctx.formData.educationStage,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _ctx.formData.educationStage = $event),
        type: "educationStage"
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 512), [[_vShow, false]]), _ctx.formData.educationStage != 7 ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 0,
      label: "部门数量",
      prop: "num"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input_number, {
        modelValue: _ctx.formData.num,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _ctx.formData.num = $event),
        onBlur: _cache[10] || (_cache[10] = val => _ctx.formData.num = _ctx.formData.num ? parseInt(_ctx.formData.num) : 0),
        min: 0,
        max: 20
      }, null, 8, ["modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
      label: "所属行政区域",
      prop: "provinces"
    }, {
      default: _withCtx(() => [_createVNode(_component_AreaSelect, {
        style: {
          "width": "100%"
        },
        placeholder: "请选择所属行政区域",
        inputValue: _ctx.selectAreaValue,
        "onUpdate:inputValue": _cache[11] || (_cache[11] = $event => _ctx.selectAreaValue = $event),
        onHandleChange: _ctx.handleSelectArea
      }, null, 8, ["inputValue", "onHandleChange"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "单位地址",
      prop: "schoolAddress"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: _ctx.formData.schoolAddress,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _ctx.formData.schoolAddress = $event),
        placeholder: "请输入单位地址"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "负责人姓名",
      prop: "headName"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: _ctx.formData.headName,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _ctx.formData.headName = $event),
        placeholder: "请输入负责人姓名"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "负责人电话",
      prop: "headPhone"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: _ctx.formData.headPhone,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => _ctx.formData.headPhone = $event),
        placeholder: "请输入负责人电话"
      }, null, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["rules", "model"])]);
}